import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Play } from 'lucide-react';

const Gallery = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const categories = {
    kitchenette: {
      name: 'Kitchen',
      images: [
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/885fctx6_624623072_781554964987700_1951070273906982112_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/6a5a9u8v_624467700_1973615519892419_1561903938972216275_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/2di8jvem_624585733_1959604521622983_5321104814325544422_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/n0t9e2dl_625022381_2742323672770201_4074171484459488215_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/zmrwuj86_610542574_1810568502990387_276701751795073548_n%20%281%29.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/9ptlqe0u_598525352_694759526902158_2178918516253509462_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/tud2jpv0_610964496_761675273631265_6109172642762828304_n%20%281%29.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/1e3gly9m_608171248_1492968612833529_5945400602268311139_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/bjgk0cq8_598664104_1398208162047985_7612617029880670438_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/ml5u4r4j_95afcf2c-7b94-42d2-b57e-93f97959da9b.jpeg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/zzfhuglb_78020c45-4c14-4154-a3cb-5e33bfd97f7e.jpeg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/3wio4xw2_50bee8cf-1da4-4825-9ecb-6b21c2d55bf6.jpeg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/ju5iq88w_1000014458.mp4',
        'https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/0ktwukzl_Comfort%20Redefined.mp4',
        'https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/bzvpb5tz_Part%203%20final.mp4',
        'https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/s5pkrkln_%40kensetsu_limuted%20prt%202.mp4',
        'https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/5053d99o_WhatsApp%20Video%202026-08-10%20at%2012.06.02%20PM.mp4',
        'https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/zb9ra600_WhatsApp%20Video%202026-07-16%20at%206.57.18%20PM%20%281%29.mp4'
      ],
      featuredIndex: 1
    },
    closet: {
      name: 'Closet',
      images: [
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/t8j8d36g_608009218_1870380070239183_8362873500106223269_n%20%281%29.jpg',
        'https://customer-assets.emergentagant.com/job_design-crafters-2/artifacts/1craibpi_624040945_896381356687583_7068844162013504794_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/17oun2ev_622335387_1616357386297219_5216344043414193480_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/lyjooplj_608719607_887811996952061_6179116943986838520_n%20%281%29.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/93sjr4w5_IMG-20250516-WA0003.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/epjt07kv_IMG-20250505-WA0002.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/z13fu4j2_1b1aee9d-8592-4023-bff3-7e4cd2a49f4b.jpeg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/zjj37sm6_74f5c4ef-747d-4535-a7b2-c45d90fac43c.jpeg',
        'https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/vyta7eyl_WhatsApp%20Video%202026-07-08%20at%2011.20.04%20AM.mp4'
      ],
      featuredIndex: 1
    },
    mediaunit: {
      name: 'Media Unit',
      images: [
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/wnimpij8_599688631_1385503096398335_1565628108689602969_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/9lpz6puj_625295604_1171988111431644_550865546874039180_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/14jgdcuu_627636125_3069874343206906_2356398876682310413_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/35999fm8_1000014438.mp4'
      ],
      featuredIndex: 1
    },
    vanity: {
      name: 'Bathroom Vanity',
      images: [
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/ov45bkqv_626277359_896396613272006_1667509559782790722_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/tqh06lcs_625956114_836959919377886_6895627965816900294_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/bmldns42_floating%20vanity.png'
      ],
      featuredIndex: 1
    },
    inspiration: {
      name: 'Be Inspired',
      images: [
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/gam02g9e_Cube%20Storage%20You%27ll%20Love%20_%20Wayfair.jpeg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/e30er1lv_622867493_1583111456716357_7864947132671205283_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/q8o7x4h1_623159770_918002384509467_4875922545492651222_n.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/7oly2ezx_IMG-20250516-WA0000.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/cwroz7n7_IMG-20250516-WA0003.jpg',
        'https://customer-assets.emergentagent.com/job_design-crafters-2/artifacts/hljl6bw6_624086457_906306875131779_8832952863803464242_n.jpg',
        'https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/eqk9ewg6_Project%20showcased.mp4',
        'https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/kdnzxlxg_Comfort%20Redefined.mp4',
        'https://customer-assets-4nw71qhi.emergentagent.net/job_54d45426-6e46-45aa-b51c-b65e128b9e72/artifacts/5w19j26b_%40kensetsu_limuted%20prt%202.mp4'
      ],
      featuredIndex: 1
    }
  };

  const openCategoryGallery = (categoryKey) => {
    setSelectedCategory(categoryKey);
    setCurrentImageIndex(0);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCategory(null);
  };

  const goToPrevious = () => {
    if (selectedCategory) {
      const images = categories[selectedCategory].images;
      setCurrentImageIndex((prevIndex) => 
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
    }
  };

  const goToNext = () => {
    if (selectedCategory) {
      const images = categories[selectedCategory].images;
      setCurrentImageIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  const isVideo = (url) => {
    return url.toLowerCase().endsWith('.mp4') || url.toLowerCase().endsWith('.mov') || url.toLowerCase().endsWith('.webm');
  };

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2C3539] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Our Work
          </h2>
          <div className="w-24 h-1 bg-[#800020] mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Click on any category to explore our custom furniture projects.
          </p>
        </div>

        {/* Category Grid - Compact Size */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6 max-w-6xl mx-auto">
          {Object.entries(categories).map(([key, category]) => (
            <div
              key={key}
              className="relative overflow-hidden rounded-xl shadow-lg cursor-pointer group bg-gradient-to-br from-white via-gray-50 to-gray-100 hover:shadow-xl transition-all duration-500 hover:-translate-y-2 border border-gray-100"
              onClick={() => openCategoryGallery(key)}
              data-category-key={key}
              style={{
                backdropFilter: 'blur(10px)',
                transform: 'translateZ(0)',
              }}
            >
              {/* Subtle shine effect on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <div className="relative p-6 sm:p-8 text-center z-10">
                <div className="mb-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-burgundy to-burgundy-dark rounded-xl mx-auto flex items-center justify-center shadow-md group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                    <span className="text-xl text-white font-bold">{category.images.length}</span>
                  </div>
                </div>
                
                <h3 className="text-lg sm:text-xl font-playfair font-light text-navy mb-2 group-hover:text-burgundy transition-colors duration-300">
                  {category.name}
                </h3>
                
                <p className="text-warm-charcoal/60 text-xs sm:text-sm mb-4 font-manrope">
                  {category.images.length} {category.images.length === 1 ? 'Item' : 'Items'}
                </p>
                
                <div className="inline-flex items-center gap-1 bg-burgundy text-white px-4 py-2 rounded-full group-hover:bg-burgundy-dark transition-all duration-300 font-manrope font-semibold text-xs uppercase tracking-wider shadow-md">
                  <span>Explore</span>
                  <svg className="w-3 h-3 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
              
              {/* Bottom accent line */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-burgundy via-gold to-burgundy transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Full Screen Modal Gallery */}
      {isModalOpen && selectedCategory && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
          {/* Close Button */}
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
            onClick={closeModal}
          >
            <X size={36} />
          </button>

          {/* Category Title */}
          <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-white text-center z-10">
            <h3 className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
              {categories[selectedCategory].name}
            </h3>
          </div>

          {/* Previous Button */}
          <button
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors bg-black/50 p-3 rounded-full hover:bg-black/70"
            onClick={goToPrevious}
          >
            <ChevronLeft size={32} />
          </button>

          {/* Current Image or Video */}
          <div className="text-center max-w-6xl mx-auto">
            {isVideo(categories[selectedCategory].images[currentImageIndex]) ? (
              <video
                key={currentImageIndex}
                controls
                autoPlay
                className="max-w-full max-h-[80vh] object-contain rounded-lg"
              >
                <source src={categories[selectedCategory].images[currentImageIndex]} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={categories[selectedCategory].images[currentImageIndex]}
                alt={`${categories[selectedCategory].name} ${currentImageIndex + 1}`}
                className="max-w-full max-h-[80vh] object-contain rounded-lg"
              />
            )}
            <p className="text-white text-lg mt-4">
              {currentImageIndex + 1} / {categories[selectedCategory].images.length}
            </p>
          </div>

          {/* Next Button */}
          <button
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-300 transition-colors bg-black/50 p-3 rounded-full hover:bg-black/70"
            onClick={goToNext}
          >
            <ChevronRight size={32} />
          </button>

          {/* Thumbnail Strip at Bottom */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 overflow-x-auto max-w-full px-4">
            {categories[selectedCategory].images.map((item, index) => (
              <button
                key={index}
                className={`flex-shrink-0 relative ${
                  index === currentImageIndex
                    ? 'ring-4 ring-[#800020]'
                    : 'ring-2 ring-white/30 hover:ring-white/60'
                } rounded-md overflow-hidden transition-all duration-200`}
                onClick={() => setCurrentImageIndex(index)}
              >
                {isVideo(item) ? (
                  <div className="w-16 h-16 bg-black flex items-center justify-center">
                    <Play size={24} className="text-white" />
                  </div>
                ) : (
                  <img
                    src={item}
                    alt={`Thumbnail ${index + 1}`}
                    className="w-16 h-16 object-cover"
                  />
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;